var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"mt-12",attrs:{"color":"transparent","height":"480"}},[_c('GChart',{attrs:{"type":"BarChart","data":_vm.chartData,"options":_vm.chartOptions,"width":"480"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }